(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dkt-b2c-partenaires"] && !Shopify.designMode) return;
  try {
    
function initDktPartners(){const p=new URLSearchParams(location.search);if(p.get('view')==='partenaires-b2c'||p.has('preview_theme_id'))document.querySelectorAll('[data-b2c-consumer-link]').forEach(a=>{const u=new URL(a.href);u.pathname=u.pathname.replace(/pages\/particuliers$/,'');u.search='view=particuliers&preview_theme_id=188455059785';a.href=u.toString();});}initDktPartners();document.addEventListener('shopify:section:load',initDktPartners);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-client-entry"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dkt-entry-film')) {
    customElements.define('dkt-entry-film', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.video.muted = true;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = true;
        this.userPaused = false;
        this.manualPlayback = false;
        this.start = Number(this.video.dataset.start) || 0;
        this.end = Number(this.video.dataset.end) || Infinity;
        this.loopStart = Number(this.video.dataset.loopStart) || this.start;
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (!this.userPaused) this.manualPlayback = true;
          this.updatePlayback();
        }, options);
        this.video.addEventListener('loadedmetadata', () => {
          if (this.video.currentTime < this.start) this.video.currentTime = this.start;
        }, options);
        const showVideo = () => {
          if (this.video.currentTime >= this.start) this.setAttribute('data-video-ready', '');
          this.updateButton();
        };
        this.video.addEventListener('playing', showVideo, options);
        this.video.addEventListener('seeked', showVideo, options);
        this.video.addEventListener('timeupdate', () => {
          if (!this.video.seeking && this.video.currentTime >= this.end) this.video.currentTime = this.loopStart;
        }, options);
        this.video.addEventListener('pause', () => this.updateButton(), options);
        this.video.addEventListener('error', () => {
          this.removeAttribute('data-video-ready');
          this.userPaused = true;
          this.updateButton();
        }, options);
        this.motion.addEventListener('change', () => {
          this.manualPlayback = false;
          this.updatePlayback();
        }, options);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        window.addEventListener('pageshow', () => this.updatePlayback(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.updatePlayback();
          }, { threshold: .05 });
          this.observer.observe(this.querySelector('.dktentry__hero'));
        }
        this.updatePlayback();
      }
      updatePlayback() {
        const motionAllowed = this.manualPlayback || (!this.motion.matches && !navigator.connection?.saveData);
        const shouldPlay = motionAllowed && this.visible && !document.hidden && !this.userPaused;
        if (!shouldPlay) {
          this.video.pause();
          this.updateButton();
          return;
        }
        if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src + '#t=' + this.start;
        this.video.play().catch(() => {
          if (this.visible && !document.hidden) {
            this.userPaused = true;
            this.updateButton();
          }
        });
      }
      updateButton() {
        const paused = this.video.paused;
        this.button.querySelector('[data-play]').hidden = !paused;
        this.button.querySelector('[data-pause]').hidden = paused;
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-concept-film-bilingual"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dkt-concept-film]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const buttons = Array.from(section.querySelectorAll('[data-language]'));
    const videos = Array.from(section.querySelectorAll('[data-video-language]'));
    const activate = (language) => {
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.language === language)));
      videos.forEach((panel) => {
        const active = panel.dataset.videoLanguage === language;
        panel.hidden = !active;
        if (!active) panel.querySelector('video')?.pause();
      });
    };
    buttons.forEach((button) => button.addEventListener('click', () => activate(button.dataset.language)));
    activate(section.dataset.defaultLanguage === 'en' ? 'en' : 'fr');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-consulting-tv"] && !Shopify.designMode) return;
  try {
    
  function initializeDktTv(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const buttons = root.querySelectorAll('[data-dkttv-language]');
    const films = root.querySelectorAll('[data-dkttv-film]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      const language = button.dataset.dkttvLanguage;
      if (root.dataset.language === language) return;
      root.dataset.language = language;
      films.forEach((film) => {
        const current = film.querySelector('[data-dkttv-player]:not([hidden]) video');
        const wasPlaying = current && !current.paused;
        const wasMuted = current ? current.muted : false;
        film.querySelectorAll('[data-dkttv-player]').forEach((pane) => {
          const video = pane.querySelector('video');
          if (video) video.pause();
          pane.hidden = pane.dataset.dkttvPlayer !== language;
          if (!pane.hidden && video && wasPlaying) {
            video.muted = wasMuted;
            video.play().catch(() => {});
          }
        });
      });
      buttons.forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.dkttvLanguage === language)));
    }));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) entry.target.querySelectorAll('video').forEach((video) => video.pause());
      }), { threshold: 0.35 });
      films.forEach((film) => observer.observe(film));
    }
    root.querySelectorAll('video').forEach((video) => video.addEventListener('play', () => {
      root.querySelectorAll('video').forEach((other) => { if (other !== video) other.pause(); });
    }));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) root.querySelectorAll('video').forEach((video) => video.pause());
    });
  }
  document.querySelectorAll('[data-dkt-tv]').forEach(initializeDktTv);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-dkt-tv]').forEach(initializeDktTv));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-immersive-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dkt-immersive')) {
    customElements.define('dkt-immersive', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        this.video = this.querySelector('video');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.small = matchMedia('(max-width: 749px)');
        this.onFrame = () => { if (!this.raf) this.raf=requestAnimationFrame(()=>{this.raf=0;this.update();}); };
        this.motion.addEventListener('change',()=>this.configure(),options);
        this.small.addEventListener('change',()=>this.configure(),options);
        window.addEventListener('scroll',this.onFrame,{...options,passive:true});
        window.addEventListener('resize',this.onFrame,options);
        window.addEventListener('pageshow',this.onFrame,options);
        this.video.addEventListener('loadedmetadata',()=>{this.update();},options);
        this.video.addEventListener('seeked',()=>{this.setAttribute('data-ready','');this.seek();},options);
        this.video.addEventListener('error',()=>this.staticView(),options);
        this.configure();
      }
      disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.raf);clearTimeout(this.mediaTimeout);this.video?.pause();}
      staticView(){
        this.removeAttribute('data-motion');this.removeAttribute('data-ready');this.removeAttribute('data-ending');this.removeAttribute('data-final');
        ['--shrink','--intro-opacity','--beat-opacity','--end-opacity','--progress'].forEach(p=>this.style.removeProperty(p));
        const intro=this.querySelector('.dkti__intro');intro.inert=false;
      }
      configure(){
        clearTimeout(this.mediaTimeout);
        this.staticView();
        if(this.motion.matches || this.dataset.static==='true' || navigator.connection?.saveData) {
          this.video.removeAttribute('src');this.video.load();return;
        }
        this.video.src=this.small.matches?this.video.dataset.mobile:this.video.dataset.desktop;
        this.video.preload='auto';this.video.load();
        this.setAttribute('data-motion','');
        this.mediaTimeout=setTimeout(()=>{if(this.video.readyState<2)this.staticView();},12000);
        this.onFrame();
      }
      update(){
        if(!this.hasAttribute('data-motion'))return;
        const r=this.getBoundingClientRect();
        const pin=this.querySelector('.dkti__pin');
        const clamp=v=>Math.min(1,Math.max(0,v));
        const stickyTop=parseFloat(getComputedStyle(pin).top)||0;
        const p=clamp((stickyTop-r.top)/Math.max(1,r.height-pin.clientHeight));
        const intro=1-clamp(p/.22),end=clamp((p-.72)/.25);
        this.style.setProperty('--progress',p.toFixed(3));
        this.style.setProperty('--intro-opacity',intro.toFixed(3));
        this.style.setProperty('--beat-opacity',(clamp((p-.26)/.15)*(1-clamp((p-.57)/.14))).toFixed(3));
        this.style.setProperty('--end-opacity',end.toFixed(3));
        this.style.setProperty('--shrink',end.toFixed(3));
        this.toggleAttribute('data-ending',end>.05);
        this.querySelector('.dkti__intro').inert=intro<.05;
        this.querySelector('[data-progress]').textContent=String(Math.round(p*100)).padStart(2,'0');
        this.target=clamp(p/.82)*Math.max(0,(this.video.duration||0)-.04);
        this.toggleAttribute('data-final',p>.84);
        this.seek();
      }
      seek(){
        if(!this.hasAttribute('data-motion')||this.video.readyState<1||this.video.seeking||!Number.isFinite(this.target))return;
        if(Math.abs(this.video.currentTime-this.target)>.025)this.video.currentTime=this.target;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-intro-splash"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'dkt-intro-seen-v1';

    const hideIntro = (root) => {
      if (root.dataset.finished === 'true') return;
      root.dataset.finished = 'true';
      root.classList.add('is-leaving');
      document.documentElement.classList.remove('dkt-intro-lock');
      window.setTimeout(() => {
        root.remove();
      }, 820);
    };

    const initIntro = () => {
      document.querySelectorAll('[data-dkt-intro]').forEach((root) => {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';

        const designMode = Boolean(window.Shopify && window.Shopify.designMode);
        const playOnce = root.dataset.playOnce === 'true';

        try {
          if (playOnce && !designMode && window.sessionStorage.getItem(storageKey) === 'true') {
            root.remove();
            return;
          }
        } catch (error) {
          // Storage can be unavailable in strict privacy modes. The intro still plays normally.
        }

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const parsedDuration = Number.parseInt(root.dataset.duration || '', 10);
        const duration = prefersReducedMotion
          ? 900
          : Math.min(6000, Math.max(3000, Number.isFinite(parsedDuration) ? parsedDuration : 4750));

        document.documentElement.classList.add('dkt-intro-lock');
        root.classList.add('is-active');

        window.requestAnimationFrame(() => {
          root.classList.add('is-mounted');
        });

        const finish = () => {
          try {
            if (playOnce && !designMode && window.sessionStorage)  {
              window.sessionStorage.setItem(storageKey, 'true');
            }
          } catch (error) {
            // Non-critical persistence failure.
          }
          hideIntro(root);
        };

        const timer = window.setTimeout(finish, duration);
        const skip = root.querySelector('[data-dkt-intro-skip]');

        if (skip) {
          skip.addEventListener(
            'click',
            () => {
              window.clearTimeout(timer);
              finish();
            },
            { once: true }
          );
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initIntro, { once: true });
    } else {
      initIntro();
    }

    document.addEventListener('shopify:section:load', initIntro);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-nike-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dkt-nike-feature')) {
    customElements.define('dkt-nike-feature', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        button.hidden = false;
        button.addEventListener('click', () => {
          video.play().catch(() => { button.hidden = false; });
        });
        video.addEventListener('playing', () => { button.hidden = true; });
        video.addEventListener('ended', () => { button.hidden = false; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-particuliers"] && !Shopify.designMode) return;
  try {
    

function initDktB2c(){
  document.querySelectorAll('[data-dkt-b2c]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const occasion=root.querySelector('[data-b2c-occasion]'),format=root.querySelector('[data-b2c-format]'),order=root.querySelector('[data-b2c-order]'),details=root.querySelector('#B2CCheckout'),submit=order.querySelector('button[type=submit]'),status=root.querySelector('[data-checkout-status]'),recovery=root.querySelector('[data-checkout-recovery]');
    let busy=false;
    const updateOffer=()=>{
      const selected=format.selectedOptions[0];
      const summary=[...root.querySelectorAll('template[data-order-summary]')].find(t=>t.dataset.orderSummary===selected.dataset.offer);
      root.querySelector('[data-b2c-order-summary]').textContent=summary.content.textContent;
      submit.disabled=busy||submit.dataset.checkoutEnabled!=='true'||selected.dataset.available!=='true';
      status.textContent=submit.disabled&&!busy?status.dataset.unavailable:'';
    };
    const pickFormat=value=>{const option=[...format.options].find(o=>o.dataset.offer===value);if(option){format.value=option.value;updateOffer();}};
    const pick=value=>{if(![...occasion.options].some(o=>o.value===value))return;occasion.value=value;root.querySelectorAll('[data-occasion]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.occasion===value)));};
    root.querySelectorAll('[data-occasion]').forEach(b=>b.addEventListener('click',()=>pick(b.dataset.occasion)));
    occasion.addEventListener('change',()=>pick(occasion.value));
    format.addEventListener('change',updateOffer);
    root.querySelectorAll('a[href="#B2CCheckout"]').forEach(a=>a.addEventListener('click',()=>{if(a.dataset.format)pickFormat(a.dataset.format);details.open=true;}));
    const params=new URLSearchParams(location.search);
    if(params.has('occasion')){
      pick(params.get('occasion'));
      const message=[...root.querySelectorAll('template[data-b2c-message]')].find(t=>t.dataset.b2cMessage===occasion.value);
      if(message){root.querySelector('[data-b2c-title]').textContent=message.content.querySelector('span').textContent;root.querySelector('[data-b2c-intro]').textContent=message.content.querySelector('p').textContent;}
    }
    pickFormat(params.get('format'));
    const campaign=params.get('utm_campaign');if(campaign&&/^[a-zA-Z0-9_-]{1,80}$/.test(campaign))root.querySelector('[data-b2c-campaign]').value=campaign;
    root.querySelectorAll('[data-attribution]').forEach(input=>{const value=params.get(input.dataset.attribution);if(value&&/^[a-zA-Z0-9_-]{1,80}$/.test(value))input.value=value;});
    if(params.has('preview_theme_id')||params.get('view')==='particuliers'){
      const link=root.querySelector('[data-b2c-partner-link]');const url=new URL(link.href);
      url.pathname=url.pathname.replace(/pages\/partenaires-evenements$/,'');url.search='';url.searchParams.set('view','partenaires-b2c');if(params.has('preview_theme_id'))url.searchParams.set('preview_theme_id',params.get('preview_theme_id'));link.href=url.toString();
    }
    order.addEventListener('submit',async event=>{
      event.preventDefault();if(busy||submit.disabled)return;
      busy=true;submit.disabled=true;status.textContent=status.dataset.busy;recovery.hidden=true;
      try{
        const response=await fetch(root.dataset.cartAdd,{method:'POST',headers:{Accept:'application/json'},body:new FormData(order)});
        if(!response.ok){busy=false;updateOffer();status.textContent=status.dataset.error;return;}
        // Shopify processes checkout from the existing cart; never clear another purchase.
        const checkout=document.createElement('form');checkout.method='POST';checkout.action=root.dataset.cartUrl;
        const go=document.createElement('input');go.type='hidden';go.name='checkout';go.value='';checkout.appendChild(go);document.body.appendChild(checkout);checkout.submit();
      }catch(error){
        // A lost response may still mean the item was added. Do not retry automatically.
        status.textContent=status.dataset.error;recovery.hidden=false;
      }
    });
    updateOffer();
    if(location.hash==='#B2CCheckout')details.open=true;
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initDktB2c);else initDktB2c();document.addEventListener('shopify:section:load',initDktB2c);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-portfolio-gallery-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dkt-tv').forEach((television) => {
    const dialog = television.parentElement.querySelector('[data-dkt-dialog]');
    if (!dialog) return;
    const player = dialog.querySelector('[data-dkt-player]');
    const title = dialog.querySelector('[data-dkt-title]');
    const type = dialog.querySelector('[data-dkt-type]');
    const description = dialog.querySelector('[data-dkt-description]');
    const close = dialog.querySelector('[data-dkt-close]');
    const languageButtons = dialog.querySelectorAll('[data-dkt-lang]');
    let selectedChannel = null;
    let selectedLanguage = 'fr';

    const loadLanguage = (language, autoplay = true) => {
      if (!selectedChannel) return;
      selectedLanguage = language;
      const source = language === 'en' ? selectedChannel.dataset.srcEn : selectedChannel.dataset.srcFr;
      const currentTime = Number.isFinite(player.currentTime) ? player.currentTime : 0;
      player.src = source;
      player.load();
      player.addEventListener('loadedmetadata', () => {
        if (currentTime > 0 && currentTime < player.duration) player.currentTime = currentTime;
        if (autoplay) player.play().catch(() => {});
      }, { once: true });
      languageButtons.forEach((button) => {
        const active = button.dataset.dktLang === language;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    television.querySelectorAll('[data-dkt-channel]').forEach((channel) => {
      channel.addEventListener('click', () => {
        selectedChannel = channel;
        title.textContent = channel.dataset.title;
        type.textContent = channel.dataset.type;
        description.textContent = channel.dataset.description;
        dialog.showModal();
        loadLanguage('fr');
      });
    });

    languageButtons.forEach((button) => {
      button.addEventListener('click', () => loadLanguage(button.dataset.dktLang));
    });

    const closeDialog = () => {
      player.pause();
      player.removeAttribute('src');
      player.load();
      selectedChannel = null;
      selectedLanguage = 'fr';
      dialog.close();
    };

    close.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-ralph-feature"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dkt-ralph-film')) {
  customElements.define('dkt-ralph-film', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const video = this.querySelector('video');
      this.querySelector('.dktrfilm__watch')?.addEventListener('click', () => {
        video?.play().catch(() => {});
      }, { signal: this.abort.signal });
      video?.addEventListener('play', () => {
        document.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-visual-proof-v2"] && !Shopify.designMode) return;
  try {
    
  (function dktVisualProofMotion(){
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.dkt-visual-proof__video').forEach(function(video){
      video.removeAttribute('autoplay');
      video.pause();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dkt-visual-proof"] && !Shopify.designMode) return;
  try {
    
  (function dktVisualProofMotion(){
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.dkt-visual-proof__video').forEach(function(video){
      video.removeAttribute('autoplay');
      video.pause();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
